import { formatDateWithTimeAMPM, TipoParametroChoiceEnum } from "@/shared";
import ImagesWithZoom from "@/shared/components/ui/Images/ImagesWithZoom";
import { VistoPor } from "@/shared/interfaces";
import { ListItem, ListItemText, Paper, Typography } from "@mui/material";
type BitacoraMessageProps = {
  sender: boolean;
  message: string;
  timestamp: string;
  type: TipoParametroChoiceEnum;
  user: string;
  key: string;
  //leido: string
  visto_por_tipo: string
  visto_por: VistoPor[] | null
};


export default function BitacoraMessage({
  message, sender, key, timestamp, user, type, visto_por_tipo
}: BitacoraMessageProps) {


  return (
    <ListItem sx={{
      background: '#F8FAFC',
      padding: '5px',
      marginBottom: '1px'
    }}>
      <ListItemText
        secondary={
          <>

            <Typography
              variant="caption"
              display="block"
              color={'inherit'}>
              {`${user}`}
            </Typography>

            {type == TipoParametroChoiceEnum.TEXTO && (
              <Typography
                variant="body2"
                color={'black'}>
                {message}
              </Typography>
            )}

            {type == TipoParametroChoiceEnum.IMAGE && (

              <ImagesWithZoom
                src={`${message}?v=${new Date().getTime()}`}
                alt={``}
              />

            )}


            <Typography
              variant="caption"
              display="block"
              color={'inherit'}>
              {`${formatDateWithTimeAMPM(timestamp)}`}
            </Typography>

            <Typography
              variant="caption"
              display="block"
              color={'inherit'}
              fontSize={10}
              >
              {`Visto por: ${visto_por_tipo}`}
            </Typography>

          </>
        }
      />

    </ListItem>
  )
  return (
    <ListItem
      key={key}
      sx={{
        flexDirection: sender ? 'row-reverse' : 'row',
        alignItems: 'flex-start',
      }}
    >

      <Paper
        elevation={2}
        sx={{
          p: 2,
          maxWidth: '70%',
          bgcolor: sender ? 'primary.light' : 'background.paper',
          color: sender ? 'primary.contrastText' : 'text.primary',
        }}
      >
        <ListItemText
          secondary={
            <>
              {type == TipoParametroChoiceEnum.TEXTO && (
                <Typography
                  variant="body2"
                  color={'black'}>
                  {message}
                </Typography>
              )}

              {type == TipoParametroChoiceEnum.IMAGE && (
                <img
                  src={message}
                  alt="media content"
                  style={{ width: '100%', borderRadius: '8px', maxHeight: '300px', objectFit: 'cover', height: 'auto' }}
                />
              )}
              <Typography
                variant="caption"
                display="block"
                color={'inherit'}>
                {`${user} / ${timestamp}`}
              </Typography>

              {/* <Typography 
                variant="caption"
                display="block"
                color={sender ? 'inherit' : 'text.secondary'}>
                {timestamp}
              </Typography> */}
            </>
          }
        />
      </Paper>
    </ListItem>
  )

}